import type { Locale } from "@/shared/i18n/messages";
import { formatNumber } from "@/shared/lib/format";

/** Above this, the badge stops counting: "9+". */
export const BADGE_MAX = 9;

/**
 * The bell's badge: nothing at zero, the count up to nine, then "9+" (in the locale's digits,
 * so "٩+" in Arabic). The exact number is in the button's label for screen readers.
 */
export function badgeText(count: number, locale: Locale): string | null {
  if (count <= 0) return null;
  if (count > BADGE_MAX) return `${formatNumber(BADGE_MAX, locale)}+`;
  return formatNumber(count, locale);
}
